import CardConstructor from "../components/CardConstructor";
import styled from "styled-components";
import ProfilePic from "../imgs/freddie-profile-pic.png";
import InitialsBackground from "../components/InitialsBackground";

const BookCall = () => {
  return (
    <Wrapper>
      <InitialsBackground />
      <CardConstructor
        title={<span className="page-title">Private Session</span>}
        content={
          <div>
            <p className="page-content">
              Ready to bring your LifePlan to life? Looking to get some clarity
              — in life, in business, or somewhere in between? Or just want to
              connect with Freddie?
            </p>
            <p className="page-content other-paragraph">
              This is by invitation and limited availability.
            </p>

            <p className="page-content other-paragraph">
              If you’re here, you’re in the right place.
            </p>

            <a
              className="btn profile-pic-btn"
              href="https://calendly.com/btb-fred"
              target="_blank"
              rel="noreferrer"
            >
              <img src={ProfilePic} alt="profile-pic" />{" "}
              <span>Book a call with Freddie</span>
            </a>
            <p className="page-content other-paragraph">
              <i>
                Prefer a direct line? Reach out at <u>freddie@yourdomain.com</u>
                . I’ll reply myself.
              </i>
            </p>
          </div>
        }
      />
    </Wrapper>
  );
};

export default BookCall;

const Wrapper = styled.div`
  .page-title {
    font-weight: 700;
    font-size: 40px;
    padding: 15px 0;
  }

  .page-content {
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 145%;
    letter-spacing: -0.3px;
    font-variant-numeric-zero: slashed-zero;
  }

  .other-paragraph {
    padding-top: 25px;
  }

  .profile-pic-btn {
    text-transform: none;
    background-color: #243aff;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    width: 42%;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    margin-top: 25px;
  }

  .profile-pic-btn > img {
    width: 24px;
    height: 24px;
    margin-right: 15px;
    letter-spacing: -0.5px;
  }

  @media only screen and (max-width: 650px) {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    margin-bottom: 85px;

    .page-title {
      font-size: 26px;
    }

    .page-content {
      font-size: 16px;
    }

    .other-paragraph {
      padding-top: 12px;
    }

    .profile-pic-btn {
      font-size: 15px;
      margin-top: 12px;
      width: unset;
    }
  }
`;
